import { render, staticRenderFns } from "./HelpBannerComponent.vue?vue&type=template&id=68ed8a78"
import script from "./HelpBannerComponent.vue?vue&type=script&lang=ts"
export * from "./HelpBannerComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports